<template>
  <div>
    <div class="text-center overflow-x-scroll sm:overflow-hidden">
      <section class="md:flex justify-center items-center my-12 relative hidden">
        <div v-for="(step, index) in steps" :key="index" class="w-1/4 relative z-50">
          <div
            v-if="index === 0 || index === steps.length - 1"
            class=""
            :class="{
              'left-0': index === 0,
              'right-0': index === steps.length - 1,
            }"
          ></div>
          <button
            type="button"
            class="w-12 h-12 focus:outline-none mx-auto rounded-full bg-white border-2 text-gray 500 flex justify-center items-center text-xl"
            :class="{
              'bg-white text-black border-gray-500': currentStep != index,
              'active-step text-white': currentStep == index,
            }"
            @click="makeActive(index)"
          >
            {{ index + 1 }}
          </button>
          <div
            class="text-center text-gray-500 mt-2 text-lg font-bold leading-tight"
            :class="{
              'text-black': currentStep != index,
              'active-step-text': currentStep == index,
            }"
          >
            {{ step.name }}
          </div>
        </div>
        <div
          class="absolute flex items-center inset-y-0 justify-center z-10"
          style="width: 75%; top: -2rem"
        >
          <div class="border-2 border-dashed border-gray-500 w-full"></div>
        </div>
      </section>

      <!-- <div class="inline-flex items-start justify-center relative overflow-hidden space-y-8 lg:space-y-0">
                <div class="absolute left-0 right-0 mt-12 lg:mt-5 border border-dashed"></div>
                <div v-for="(step, index) in steps"
                     :key="index"
                     class="flex flex-col items-center px-4 z-0 relative w-full lg:w-56">
                    <div v-if="index === 0 || index === (steps.length - 1)"
                         class="absolute bg-white w-16 lg:w-24 h-10"
                         :class="{
                             'left-0': index === 0,
                             'right-0': index === (steps.length - 1)
                         }"></div>
                    <button type="button"
                            class="w-10 h-10 z-0 flex items-center justify-center border rounded-full focus:outline-none"
                            :class="{
                                'bg-white text-black border-gray-500': currentStep != index,
                                'bg-purple-600 text-white border-purple-700': currentStep == index,
                            }"
                            @click="makeActive(index)">
                        {{ index + 1 }}
                    </button>
                    <div class="mt-4 text-xs lg:text-base"
                         :class="{
                             'text-black': currentStep != index,
                             'text-purple-700': currentStep == index,
                         }">{{ step.name }}</div>
                </div>
            </div> -->
    </div>

    <div
      class="py-10 px-5 md:px-20 rounded-lg mt-5 md:mt-0"
      style="background-image: linear-gradient(to right, #5d2bff, #2c86de)"
    >
      <section>
        <div
          v-for="(step, index) in steps" :key="index"
          class="flex space-x-6 items-center md:hidden"
        >
          <div v-if="currentStep == index" class="flex items-center space-x-2">
            <div
              class="w-16 h-16 rounded-full border-4 border-white shrink-0 flex justify-center items-center font-extrabold text-white text-lg tracking-wide"
            >
              {{ step.step }} / 4
            </div>
            <p
              class="font-extrabold text-lg text-white whitespace-nowrap "
              v-html="step.name"
            ></p>
          </div>
        </div>

        <!-- <div class="flex justify-center space-x-6 items-center md:hidden">
          <div class="w-16 h-16 rounded-full border-4 border-white shrink-0 flex justify-center items-center font-bold text-white text-lg tracking-wide">1/4</div>
          <p class="font-bold text-base text-white whitespace-nowrap">Teacher Account</p>
        </div> -->
      </section>
      <div>
        <div
          v-for="(step, index) in steps"
          :key="index"
          v-show="currentStep === index"
          class="text-white text-center md:px-32 tracking-wide text-lg hidden md:block"
          v-html="step.desc"
        ></div>
      </div>

      <div>
        <slot :is-last-step="isLastStep" />

        <div class="mt-8 flex items-center justify-center space-x-8 px-6">
          <button
            type="button"
            v-if="!isFirstStep"
            class="border-2 px-8 md:px-16 py-3 rounded-full focus:outline-none"
            style="border-color: #83eda3; color: #83eda3"
            @click="showPreviousStep"
          >
            Previous
          </button>
          <button
            type="button"
            v-if="!isLastStep"
            class="px-8 md:px-16 py-3 rounded-full focus:outline-none"
            style="background: #83eda3"
            @click="showNextStep"
          >
            Next
          </button>
          <div v-show="isLastStep">
            <button
              class="px-8 md:px-16 py-3 rounded-full focus:outline-none"
              style="background: #83eda3"
              :disabled="loading"
              @click.prevent="handleSubmit"
            >
              <span v-if="loading">Submitting</span>
              <span v-else>
                <span v-if="res">Reschedule</span>
                <span v-else>Submit</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    initData: {},
    isInfluencerCampaign: {},
    loading: {
      type: Boolean,
    },
    res: {
      type: Boolean,
    },
  },

  data() {
    return {
      currentStep: 0,
    };
  },

  computed: {
    stepOneTrialDesc() {
      return this.isInfluencerCampaign
        ? "Please select a date/time in September to book a 20-minute call to discuss your trial account.<br/>One of our team will walk you through the platform so you can make the most of your free access.<br/><br/>Once the meeting has been attended, your trial will start on <strong>Monday 2nd October 2023</strong>."
        : "Please select a date/time to book in a 20-minute call to discuss your trial account.<br/>One of our team will walk you through the platform so you can make the most of your free access.";
    },

    steps() {
      return [
        {
          name: this.initData.webinar ? "Trial Webinar" : "Book a Trial Meeting",
          desc: this.initData.webinar
            ? "Please select a date/time to join one of our training webinars.<br/>One of our team will walk you through the platform so you can make the most of your free access."
            : this.stepOneTrialDesc,
          step: 1,
        },
        { name: "School Info", desc: "", step: 2 },
        {
          name: "Teacher Accounts",
          desc: "Add any additional teachers who require access to a trial account.",
          step: 3,
        },
        {
          name: "Pupil Accounts",
          desc:
            "Finally, please enter the number of pupils in each year group below who need trial access.",
          step: 4,
        },
      ];
    },

    isFirstStep() {
      return this.currentStep === 0;
    },

    isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
  },

  methods: {
    handleSubmit() {
      this.$emit("handleSubmit");
    },

    makeActive(index) {
      this.currentStep = index;
    },

    showPreviousStep() {
      this.currentStep -= 1;
    },

    showNextStep() {
      this.currentStep += 1;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.currentStep = value || 0;
      },
    },

    currentStep(step) {
      this.$emit("input", step);
    },
  },
};
</script>

<style scoped>
.active-step {
  background: #4289ff;
}
.active-step-text {
  color: #4289ff;
}
</style>
